import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { VRSTA_OPERATERA } from "../../../../enums";

const nazivPolja = "registarskiBroj";

const Index = () => {
  const { register, getValues, watch } = useFormContext();
  const registarskiBroj = watch(nazivPolja);
  const operaterPlatforme = getValues("operaterPlatforme");

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) =>
    navigator.clipboard.writeText(getValues(nazivPolja));

  return (
    <FormControl fullWidth sx={{ mt: 3 }}>
      {operaterPlatforme && operaterPlatforme.vrstaOperatera && (
        <InputLabel htmlFor={nazivPolja}>
          {operaterPlatforme.vrstaOperatera.id !== VRSTA_OPERATERA.IZVAN_EU
            ? "Registarski broj (Registration number)"
            : "Individualni identifikacijski broj (Individual identification number)"}
        </InputLabel>
      )}
      <Input
        value={registarskiBroj || ""}
        defaultValue={registarskiBroj || ""}
        {...register(nazivPolja)}
        disabled
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClick}
              edge="end"
            >
              <ContentCopyIcon />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

export default Index;
